import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';
import { VehicleType } from 'types/UFOTypes';

interface VehicleOptionProps {
  vehicle: VehicleType;
}

export function VehicleInformation(props: VehicleOptionProps) {
  const { t } = useTranslation();
  const { vehicle } = props;
  const {
    id,
    year,
    make_name,
    model_name,
    option_name,
    fleet_id_no,
    vin,
    license_plate,
    color,
    license_state_abbreviation,
    tire_sw = '',
    tire_aspect = '',
    tire_rim = '',
    load_index = '',
  } = vehicle;

  const tire_size_name = vehicle?.tire_size_name?.toUpperCase().includes('CUSTOM')
    ? `${tire_sw}/${tire_aspect} R${tire_rim} ${load_index}`
    : vehicle.tire_size_name;

  if (!id) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span>
        <Typography>
          <b>{`${year || ''} ${make_name || ''} ${model_name || ''} ${option_name || ''}`}</b>
          <br />
          <span style={{ whiteSpace: 'nowrap' }}>
            {fleet_id_no && (
              <>
                {t('Unit: {{fleet_id_no}} ', { fleet_id_no })}
                <br />
              </>
            )}
            {vin && (
              <>
                {t('VIN: {{vin}}', { vin })}
                <br />
              </>
            )}
            {license_plate && (
              <>
                {t('License plate: {{license_plate}} ', { license_plate })}
                <br />
              </>
            )}
            {license_state_abbreviation && (
              <>
                {t('State: {{license_state_abbreviation}}', { license_state_abbreviation })}
                <br />
              </>
            )}
            {color && (
              <>
                {t('Color: {{color}}', { color })}
                <br />
              </>
            )}
            {tire_size_name && (
              <>
                {t('Tire size: {{tire_size_name}}', { tire_size_name })}
                <br />
              </>
            )}
          </span>
        </Typography>
      </span>
    </div>
  );
}
